module.exports = __webpack_public_path__ + "static/media/数字孪生行业应用-智慧物流-01.786915d8.jpg";